// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, signOut } from "firebase/auth";
import store from '@/store';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCWTDnwmg2R-X-w9xHzpn47t7I0Ynb4iQQ",
  authDomain: "dds-916hub.firebaseapp.com",
  projectId: "dds-916hub",
  storageBucket: "dds-916hub.appspot.com",
  messagingSenderId: "903188796195",
  appId: "1:903188796195:web:72ff13f44fd0bb9220f296"
};

const auth = {
  userPromise: null,
  gAuth: null,

  init() {
    initializeApp(firebaseConfig);
    this.gAuth = getAuth();
    // this.gAuth.onAuthStateChanged(() => store.dispatch('setCurrentUser'));

    this.userPromise = new Promise(resolve => {
      if (store.state.user) {
        resolve(true);
      } else {
        const unsubscribe = this.gAuth.onAuthStateChanged(function (user) {
          unsubscribe();
          if (user) {
            store.dispatch('setCurrentUser').then(() => {
              resolve(true);
            });
          } else {
            resolve(false);
          }
        });
      }
    });

    return this.userPromise
  },
  user() {
    return this.gAuth.currentUser;
  },
  logout() {
    return signOut(this.gAuth);
  }
}

export default auth;